const McpPlaygroundActions = {
  LIST_LOADED: "playground-list/loaded",
  PUBLIC_PLAYGROUND_LOADED: "public-playground/loaded",
};

export default McpPlaygroundActions;
